export default {
  // Config
   apiKey: "AIzaSyAB6um7gwmixwuawr3Z80cOyBpXDAz6PyU",
  authDomain: "dutchpackaging-mytrace.firebaseapp.com",
  projectId: "dutchpackaging-mytrace",
  storageBucket: "dutchpackaging-mytrace.firebasestorage.app",
  messagingSenderId: "216032133991",
  appId: "1:216032133991:web:f5f3a4ad6a1c34ada025c2"
};
